module.exports = __webpack_public_path__ + "img/bg_giveLike.2236cd2e.png";